import { ICON_MAP as SPRITE_ICON_MAP } from '../map/sprite';
import IconLoader from './IconLoader';

/** 生成 svg element */
const createSvgElement = (svgStr: string) => {
  const box = document.createElement('div');
  box.innerHTML = svgStr;
  return box.getElementsByTagNameNS('http://www.w3.org/2000/svg', 'svg')[0]
}

/** get icon svg str from lib */
const getIconLibChunkSvgStr = (iconName: string): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      const chunk: any = await IconLoader.getIconChunk(iconName);
      const svgStr = typeof chunk === 'object' ? chunk[iconName] : chunk;
      resolve(svgStr);
    } catch {
      reject(`Can't load ${iconName}!`);
    }
  })
}


/** get icon svg str from ui */
const getIconFormUISvgStr = (iconName: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (iconName in SPRITE_ICON_MAP) {
      SPRITE_ICON_MAP[iconName]?.()
        .then((res: any) => {
          const svgStr: string = res.icons[iconName];
          resolve(svgStr);
        })
        .catch(() => {
          reject(`Can't load ${SPRITE_ICON_MAP[iconName]}`);
        })
    } else {
      reject(`Can't find ${iconName}`);
    }
  })
}

/** get icon svg str */
export const getSvgIconStr = (iconName: string): Promise<{ svgStr: string }> => {
  if (/-png$/.test(iconName)) {
    return Promise.reject(`Can't load image icon!`)
  }
  return new Promise(async (resolve, reject) => {
    try {
      // get icon from lib
      getIconLibChunkSvgStr(iconName)
        .then(svgStr => {
          resolve({ svgStr });
        })
        .catch(err => {
          // get icon from ui
          getIconFormUISvgStr(iconName)
            .then(svgStr => {
              resolve({ svgStr });
            })
            .catch(err => {
              reject(`Can't find ${iconName}!`);
            })
        })
    } catch (err) {
      reject(`Can't find ${iconName}!`);
      console.error(err);
      throw err;
    }
  })
}

/** get icon svg dom */
export const getSvgIconDom = (iconName: string): Promise<{ svgDom: SVGElement }> => {
  if (/-png$/.test(iconName)) {
    return Promise.reject(`Can't load image icon!`)
  }
  return new Promise(async (resolve, reject) => {
    try {
      getSvgIconStr(iconName)
        .then(res => {
          const svgDom = createSvgElement(res.svgStr);
          resolve({ svgDom });
        })
        .catch(err => {
          reject(`Can't find ${iconName}!`);
        })
    } catch (err) {
      console.error(err);
      reject(`Can't find ${iconName}!`);
    }
  })
}
